<template>
  <section class="extension-section">
    <div class="container">
      <div class="extension-inner fade-up">
        <div class="extension-text">
          <div class="ext-badge">
            <svg class="ext-badge__icon" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="3" width="20" height="14" rx="2.5" stroke="currentColor" stroke-width="1.8"/>
              <path d="M8 17v4M16 17v4M6 21h12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              <path d="M7 9l2.5 2.5L14 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t('extension.badge') }}
          </div>
          <h2 class="section-title" v-html="titleHtml"></h2>
          <p class="section-desc">{{ $t('extension.desc') }}</p>
          <ul class="ext-features">
            <li v-for="(item, i) in $tm('extension.features')" :key="i">
              <svg viewBox="0 0 16 16" fill="none"><polyline points="3,8 6.5,11.5 13,4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              {{ item }}
            </li>
          </ul>
          <div class="ext-buttons">
            <a
              href="https://addons.mozilla.org/en-US/firefox/addon/kordelo/"
              target="_blank"
              rel="noopener noreferrer"
              class="ext-btn ext-btn--firefox"
            >
              <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>
                <path d="M12 3C7 3 3.5 7 3.5 12c0 2.5 1 4.8 2.6 6.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                <path d="M12 3c3 1.5 5.5 4.8 5.5 9 0 2.5-.9 4.8-2.5 6.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                <path d="M3 12h18M12 3c-2.5 3-4 5.5-4 9s1.5 6 4 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                <path d="M12 3c2.5 3 4 5.5 4 9s-1.5 6-4 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
              </svg>
              {{ $t('extension.ctaFirefox') }}
            </a>
            <a
              href="https://numen.fra1.cdn.digitaloceanspaces.com/Kordelo%20Setup%201.0.0.exe"
              class="ext-btn ext-btn--windows"
              download
            >
              <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <path d="M3 5.5l7.5-1v7H3V5.5zM11.5 4.3L21 3v8.5h-9.5V4.3zM3 12.5h7.5v7L3 18.5v-6zM11.5 12.5H21V21l-9.5-1.3v-7.2z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
              </svg>
              {{ $t('extension.ctaWindows') }}
              <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><path d="M8 3v8M4.5 8l3.5 3.5L11.5 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a
              href="https://numen.fra1.cdn.digitaloceanspaces.com/Kordelo-1.0.0.AppImage"
              class="ext-btn ext-btn--linux"
              download
            >
              <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" stroke="currentColor" stroke-width="1.6"/>
                <path d="M9 9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.3-.83 2.4-2 2.82V14h-2v-2.18C9.83 11.4 9 10.3 9 9z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                <circle cx="12" cy="17" r="1" fill="currentColor"/>
              </svg>
              {{ $t('extension.ctaLinux') }}
              <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><path d="M8 3v8M4.5 8l3.5 3.5L11.5 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
          </div>
          <p class="ext-note">{{ $t('extension.note') }}</p>
        </div>

        <div class="extension-visual">
          <div class="extension-frame">
            <img src="../../../assets/browser-extension.png" alt="Kordelo browser extension" class="extension-img" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'ExtensionSection',
    computed: {
      titleHtml() {
        return this.$t('extension.title').replace('\n', '<br/>')
      }
    }
  }
</script>

<style scoped>
.extension-section {
  background: var(--bg-alt);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}

.extension-inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

/* ── Text side ─────────────────────────────────────────── */
.ext-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: rgba(91, 141, 184, 0.10);
  color: var(--primary-dark);
  border: 1px solid rgba(91, 141, 184, 0.22);
  padding: 0.3rem 0.9rem;
  border-radius: 100px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.ext-badge__icon {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}

.ext-features {
  list-style: none;
  margin: 1.25rem 0 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.ext-features li {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.9rem;
  color: var(--text-muted);
}

.ext-features li svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--secondary);
}

.ext-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}

.ext-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0.75rem 1.4rem;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: var(--radius-sm);
  text-decoration: none;
  transition: opacity 0.2s, transform 0.2s;
  flex-shrink: 0;
}

.ext-btn:hover { opacity: 0.88; transform: translateY(-1px); }

.ext-btn--firefox {
  background: #FF6611;
  color: white;
  box-shadow: 0 3px 12px rgba(255, 102, 17, 0.35);
}

.ext-btn--windows {
  background: #0078D4;
  color: white;
  box-shadow: 0 3px 12px rgba(0, 120, 212, 0.35);
}

.ext-btn--linux {
  background: var(--bg);
  color: var(--text);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.ext-note {
  margin-top: 0.75rem;
  font-size: 0.78rem;
  color: var(--text-light);
}

/* ── Visual ────────────────────────────────────────────── */
.extension-visual {
  display: flex;
  justify-content: center;
  align-items: center;
}

.extension-frame {
  display: inline-block;
  overflow: hidden;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  background: #fff;
}

.extension-img {
  display: block;
  max-height: 420px;
  margin-left: -2px;
}

/* ── Responsive ────────────────────────────────────────── */
@media (max-width: 860px) {
  .extension-inner {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .extension-visual { order: -1; }
}
</style>
